import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { CumplimientoVsGananciaService } from '../../services/cumplimiento-vs-ganancia.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cumplimiento-vs-ganancia-upload-csv',
  templateUrl: './cumplimiento-vs-ganancia-upload-csv.component.html',
  styleUrls: ['./cumplimiento-vs-ganancia-upload-csv.component.css']
})

export class CumplimientoVsGananciaCSVComponent implements OnInit {

  titulo = 'Carga de Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _serviciosCRUD: CumplimientoVsGananciaService,
    private router: Router,
  ) { }

  ngOnInit() {

    this.formulario = this.fb.group({
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGridGananciasVsIncentivos();

    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();

    this.formulario.get('multipart').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.isCorrect != undefined) {
      if (data.isCorrect === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Tipo de Vendedor',
        field: this.modelGrid.tipoVendedorDescripcion,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: 'Tipo de Variable',
        field: this.modelGrid.variableDescripcion,
        filter: true,
        width: 350,
        sortable: true
      },
      {
        headerName: '% Cumplimiento',
        field: this.modelGrid.cumplimiento,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: '% Ganancia',
        field: this.modelGrid.ganancia,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: '% Cumplimiento Final',
        field: this.modelGrid.cumplimientoFinal,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
    // this.router.navigate(['/comisiones/cumplimiento-vs-ganancia']);
  }

  regresarHome() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
    this.router.navigate(['/comisiones/cumplimiento-vs-ganancia']);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._serviciosCRUD.procesarCsv(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado?',
        text: '',
        action: 'Guardar',
        funcion: this._serviciosCRUD.saveCsv(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      // this.downloadDataCsv();
      setTimeout(() => {
        this.regresarHome();
      }, 1000);
    }).catch((err) => {
      console.log('Error ' + err);
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['CODIGO TIPO VENDEDOR', 'CODIGO DE VARIABLE', '% DE CUMPLIMIENTO', '% DE GANANCIA', '% DE CUMPLIMIENTO FINAL']];
    const data: any[] = [
      { 'tipoVendedorId': 18, 'variableId': 221, 'cumplimiento': '60', 'ganancia': '80', 'cumplimientoFinal': '80'}
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['Estado', 'Tipo Vendedor Id', 'Tipo Vendedor Descripcion', 'Variable Id', 'Variable Descripcion', 'Tipo Asignacion', 'Cumplimiento', 'Ganancia', 'Cumplimiento Final', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            tipoVendedorId: (e.tipoVendedorId === undefined) ? '' : e.tipoVendedorId,
            tipoVendedorDescripcion: (e.tipoVendedorDescripcion === undefined) ? '' : e.tipoVendedorDescripcion,
            variableId: (e.variableId === undefined) ? '' : e.variableId,
            variableDescripcion: (e.variableDescripcion === undefined) ? '' : e.variableDescripcion,
            tipoAsignacionCumplGanan: (e.tipoAsignacionCumplGanan === undefined) ? '' : e.tipoAsignacionCumplGanan,
            cumplimiento: (e.cumplimiento === undefined) ? '' : e.cumplimiento,
            ganancia: (e.ganancia === undefined) ? '' : e.ganancia,
            cumplimientoFinal: (e.cumplimientoFinal === undefined) ? '' : e.cumplimientoFinal,
            linea: (e.error.linea === undefined) ? '' : e.error.linea,
            errorCampo: (e.error.errorCampo === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

}
